module.exports = __webpack_public_path__ + "static/img/1b.7e552184.webp";